import { render, staticRenderFns } from "./parameter-settings.view.vue?vue&type=template&id=738d4889&"
import script from "./parameter-settings.view.vue?vue&type=script&lang=ts&"
export * from "./parameter-settings.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports